import { XmlRules } from '../xml-rules-check/xmlRules.class';

export class Xml2htmlAttributeWorker {
  public static DataAttribPraefix = 'data-attribute-';

  constructor(public rules: XmlRules) {}

  /** writes the given attributes to the html node in data-attribute-syntax **/
  writeAllXmlAttributesToHtml(xmlElement: Element, htmlElement: Element) {
    const attributes = xmlElement.attributes;
    for (let i = 0; i < attributes.length; ++i) {
      const attr = attributes[i];
      this.writeAttributeToHtml(htmlElement, attr.name, attr.value);
    }
  }

  /** writes the given attribute value to the html node in data-attribute-syntax **/
  writeAttributeToHtml(htmlElement: Element, key: string, value: string) {
    const name = `${Xml2htmlAttributeWorker.DataAttribPraefix}${key}`;
    if (value && value.length > 0) {
      htmlElement.setAttribute(name, value);
    } else {
      htmlElement.removeAttribute(name);
    }
    this.updateAttributesDescriptionInHtmlElement(htmlElement);
  }

  /** writes the given attribute value from the html node data-attribute-syntax **/
  getAttributeValueFromHtml(htmlElement: Element, key: string): string {
    const attributes = htmlElement.attributes;
    for (let i = 0; i < attributes.length; ++i) {
      if (attributes[i].name === `${Xml2htmlAttributeWorker.DataAttribPraefix}${key}`) {
        return attributes[i].value;
      }
    }
    return undefined;
  }

  /** writes the given attribute value to the xml node (and gets it from the html node from data-attribute-syntax) **/
  writeAllHtmlAttributesToXml(htmlElement: Element, xmlElement: Element) {
    const attributes = htmlElement.attributes;
    for (let i = 0; i < attributes.length; ++i) {
      const attr = attributes[i];
      if (attr.name.startsWith(Xml2htmlAttributeWorker.DataAttribPraefix)) {
        xmlElement.setAttribute(attr.name.substr(Xml2htmlAttributeWorker.DataAttribPraefix.length), attr.value);
      }
    }
  }

  /** updates the 'for human eyes' only description of the attributes inside a html node **/
  private updateAttributesDescriptionInHtmlElement(htmlElement: Element) {
    const attributes = htmlElement.attributes;
    let allAttributes = '';
    for (let i = 0; i < attributes.length; ++i) {
      const attr = attributes[i];
      if (attr.name.startsWith(Xml2htmlAttributeWorker.DataAttribPraefix)) {
        allAttributes = `${allAttributes} ${attr.name.substr(Xml2htmlAttributeWorker.DataAttribPraefix.length)}="${attr.value}"`;
      }
    }
    if (allAttributes.length > 0) {
      htmlElement.setAttribute('data-attributes', allAttributes);
    } else {
      htmlElement.removeAttribute('data-attributes');
    }
  }
}
